export const bzAgendaSessions = [
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3125241
            }
        ],
        "externalId": "VlimeE4zOnNgC",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Saudi Tourism Insights & Investment Platform: Overview of the Saudi Tourism Investment Services",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 900,
        "endMinute": 945,
        "id": 1210326
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3100883,
                "role": ""
            },
            {
                "speakerId": 3085250
            }
        ],
        "externalId": "ptPPwk9bnND71",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "HAMA Workshop",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 900,
        "id": 1180693
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3089650
            }
        ],
        "externalId": "L8PCjB9EX7ovE",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Cost Engineering: Detailed Development Costs Analysis and Segment-Specific Expenditure Strategies",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 860,
        "endMinute": 875,
        "descriptionHtml": "<p>(Streaming live on<a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">&nbsp;LinkedIn</a>)</p>",
        "id": 1183014
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3090566
            }
        ],
        "externalId": "TL3GpmGCKhnow",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Measuring Progress: Quantification and Benchmarking of Social & Environmental Factors",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 845,
        "endMinute": 860,
        "descriptionHtml": "<p>(Streaming live on<a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">&nbsp;LinkedIn</a>)</p>",
        "id": 1188675
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3101360
            },
            {
                "speakerId": 3113698
            },
            {
                "speakerId": 3132586,
                "role": "Moderator"
            },
            {
                "speakerId": 3131501
            }
        ],
        "externalId": "RsZnkk71YXN8d",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Impact of Third-Party Outlets on Hotel Revenue and Real Estate Value – What are the Keys to Choosing the Right Operator, Concept and Agreement?",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 695,
        "endMinute": 725,
        "id": 1198582
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721,
                    432689
                ]
            }
        ],
        "description": "Speed Networking is a great way to break the ice and ensure you go into FHS already knowing your fellow attendees. Meet over 30 new contacts before the conference has officially started! Don't forget to bring lots of business cards!  Taking place prior to the Opening Reception.",
        "private": false,
        "externalId": "YtJCu9ZL6ZOFp",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "FHS Networking Card Exchange",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 1050,
        "endMinute": 1110,
        "descriptionHtml": "<p>Speed Networking is a great way to break the ice and ensure you go into FHS already knowing your fellow attendees. Meet over 30 new contacts before the conference has officially started! Don't forget to bring lots of business cards! &nbsp;Taking place prior to the Opening Reception.</p>",
        "id": 1183626
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3119029,
                "role": "Moderator"
            },
            {
                "speakerId": 3100262
            }
        ],
        "externalId": "OdHZPMIvfH2mn",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Nurturing Growth and Shaping Travel Experiences: The Impact of Arabian Hospitality",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 605,
        "endMinute": 620,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1206363
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3096150,
                "role": "Moderator"
            },
            {
                "speakerId": 3131534
            },
            {
                "speakerId": 3079898
            },
            {
                "speakerId": 3114775
            }
        ],
        "externalId": "007DTmqSLinoE",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Expanding Horizons in Tourism Destination Development",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 540,
        "endMinute": 570,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1175753
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3130657,
                "role": "Moderator"
            },
            {
                "speakerId": 3138945
            },
            {
                "speakerId": 3074043
            },
            {
                "speakerId": 3118901
            }
        ],
        "externalId": "qlwOylgj41jCh",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Assessing the Role of Technology in Long-Term Value Creation and Its Impact on Investment Decisions",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 540,
        "endMinute": 570,
        "id": 1176699
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079863,
                "role": "Moderator"
            },
            {
                "speakerId": 3101502
            },
            {
                "speakerId": 3099015
            }
        ],
        "externalId": "9fkJFPWo3lBqN",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Why India Matters in Hospitality Investment",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 880,
        "endMinute": 900,
        "id": 1192737
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "TvDXKhagtk0yV",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Networking Coffee Break",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 630,
        "endMinute": 645,
        "id": 1168652
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "LRm2rAFuyT1kL",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Ongoing Networking Coffee Break",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 630,
        "endMinute": 660,
        "id": 1168687
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3113603,
                "role": "Moderator"
            },
            {
                "speakerId": 3132668
            },
            {
                "speakerId": 3084921
            }
        ],
        "externalId": "pTrQrWML41vTO",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Financing Hospitality Assets and Key Considerations in UAE",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 915,
        "endMinute": 935,
        "id": 1214538
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "Has the time come to re-consider the use of spaces? What are some creative solutions?",
        "private": false,
        "speakers": [
            {
                "speakerId": 3113603,
                "role": "Moderator"
            },
            {
                "speakerId": 3130905
            },
            {
                "speakerId": 3101356
            },
            {
                "speakerId": 3102015
            },
            {
                "speakerId": 3117175
            }
        ],
        "externalId": "tYANDOAa0W6zw",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "How can Asset Owners Increase ROI on their F&B?",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 620,
        "endMinute": 650,
        "descriptionHtml": "<p>Has the time come to re-consider the use of spaces? What are some creative solutions?</p>",
        "id": 1198579
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn Page)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072434,
                "role": "Moderator"
            },
            {
                "speakerId": 3138555
            },
            {
                "speakerId": 3128559
            },
            {
                "speakerId": 3133564
            }
        ],
        "externalId": "K0QzuRsmpgyjO",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Tourism-Led Policies for a Better World: The Importance of the Industry Getting a Seat at the Government Policy-making Table",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 565,
        "endMinute": 600,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn Page</a>)</p>",
        "id": 1168650
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3080558
            }
        ],
        "externalId": "H9sLcBIlc0EUi",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Welcome to the Future Hospitality Summit ",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 525,
        "endMinute": 535,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1176600
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "mkdVDKBdCoU59",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Networking Coffee Break",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 930,
        "endMinute": 960,
        "id": 1176599
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "What are some of the exciting things happening globally and in the region?",
        "private": false,
        "speakers": [
            {
                "speakerId": 3132744
            },
            {
                "speakerId": 3132743
            }
        ],
        "externalId": "iolu7dnnlRUJO",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Looking at the Innovations and Trends Which are Emerging in Hotel F&B Concepts and Design.  What are the Influences Coming Through from Other Industries?",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 590,
        "endMinute": 610,
        "descriptionHtml": "<p>What are some of the exciting things happening globally and in the region?</p>",
        "id": 1217326
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3131568,
                "role": "Moderator"
            },
            {
                "speakerId": 3083743
            },
            {
                "speakerId": 3090620
            },
            {
                "speakerId": 3091936
            },
            {
                "speakerId": 3094983
            }
        ],
        "externalId": "QJlonTJLaawyM",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Exploring Profitable Horizons: Assessing Investment in the Booming Lifestyle Midmarket Hotel Segment",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 960,
        "endMinute": 1000,
        "id": 1183138
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3128921
            }
        ],
        "externalId": "qz0c5VF5KkHcy",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Maximizing Synergies: Elevating Other Business Units and Centralized Services in Hospitality Investment",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 675,
        "endMinute": 720,
        "id": 1222633
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3121102,
                "role": "Moderator"
            },
            {
                "speakerId": 3097950
            }
        ],
        "externalId": "fDo4R43MOA7Ff",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Women Belong in the Kitchen: Pursuing Gender Equity in the Culinary World",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1020,
        "endMinute": 1035,
        "id": 1226062
    },
    {
        "private": false,
        "externalId": "czwrBJm3g9Ztu",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": " FHS Opening Lunch",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 750,
        "endMinute": 840,
        "id": 1168636
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "QQ28x7KoQOoCq",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Networking Lunch",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 810,
        "endMinute": 840,
        "id": 1168681
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3082891
            }
        ],
        "externalId": "AAkEipkjXihbY",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "What do Youth Look for Today? How to Attract and Retain Arab Youth Talent in the Hospitality Industry",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 915,
        "endMinute": 930,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1176598
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3098821
            },
            {
                "speakerId": 3072437
            }
        ],
        "externalId": "S6pnD2UJjl9Sl",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Rizwan Kassim in Conversation With Nick Van Marken on What Restaurant Brands and Operators Bring to the Table.  How do They Add Value to a Hotel’s Performance and When Does the Relationship Work Best? What Does He Look for From Potential Partners?",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 660,
        "endMinute": 675,
        "id": 1226775
    },
    {
        "private": false,
        "externalId": "E7zQ8DRHqgOG1",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Ongoing Coffee Break",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 675,
        "endMinute": 695,
        "id": 1226774
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3124584
            }
        ],
        "externalId": "A5PHqFJN1sMRC",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Imagine Beyond: The Art of Human Connection in the Future of Hospitality",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 850,
        "endMinute": 865,
        "id": 1214537
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    414723
                ]
            }
        ],
        "description": "Lace-up your running shoes and immerse yourself in the invigorating coastal breeze as we embark on a 5 km journey along the waterfront just outside the hotel that combines physical fitness with mental rejuvenation.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3126602
            }
        ],
        "externalId": "WcEPqbE6DdlWQ",
        "registrationFull": false,
        "hidden": false,
        "backgroundColor": "rgba(248,231,28,1)",
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Morning Run",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 420,
        "endMinute": 480,
        "descriptionHtml": "<p>Lace-up your running shoes and immerse yourself in the invigorating coastal breeze as we embark on a 5 km journey along the waterfront just outside the hotel that combines physical fitness with mental rejuvenation.</p>",
        "id": 1170835
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "t1wlhcb4IuK7o",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Networking Lunch",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 780,
        "endMinute": 840,
        "id": 1168662
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Fostering Talent in Hospitality: Taking a Unified Approach to Acquisition, Retention, Engagement and Training",
        "private": false,
        "speakers": [
            {
                "speakerId": 3084476,
                "role": "Moderator"
            },
            {
                "speakerId": 3132666
            },
            {
                "speakerId": 3131501
            },
            {
                "speakerId": 3079867,
                "role": ""
            },
            {
                "speakerId": 3074042
            }
        ],
        "externalId": "RICPbTYdyGucU",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Socially Responsible Talent Development in Hospitality: A Unified Approach to ESG-Driven Acquisition, Retention, Engagement",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1035,
        "endMinute": 1080,
        "descriptionHtml": "<p>Fostering Talent in Hospitality: Taking a Unified Approach to Acquisition, Retention, Engagement and Training</p>",
        "id": 1168668
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3102109
            }
        ],
        "externalId": "ysUIUE3NTdHiG",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Exclusive Data Report: What is the Reality? How is F&B Performing within Hotels in the UAE? ",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 610,
        "endMinute": 620,
        "id": 1198578
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079898
            },
            {
                "speakerId": 3136891
            },
            {
                "speakerId": 3136888
            }
        ],
        "externalId": "9PVP3jDvMymsi",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Morocco's New Tourism Roadmap: Unveiling new Investment Projects",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 945,
        "endMinute": 975,
        "id": 1204881
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "The Sustainable Hospitality Challenge is a Hotelschool The Hague initiative that aims to enhance the evolution of sustainable hospitality.\n\n\n\n\nModerator: Paul Griep, Founder of Sustainable Hospitality Challenge, Director Industry Relations & Alumni, Hotelschool The Hague \n\n\n\n\nSHC Judges:\n\n•Colin Abercrombie, Strategy Director, NEOM Hotel Development\n\n•Bernadine Galliver, Vice President: Tourism Advisory, JLL’s Hotels & Hospitality Group\n•Guy Hutchinson, President & CEO, Rotana\n\n•Glenn Mandziuk, Chief Executive Officer, Sustainable Hospitality Alliance \n•Dimitris Manikis, President EMEA, Wyndham\n•Haitham Mattar, Special Advisor, UNWTO , Managing Director MEA & South West Asia, IHG Hotels & Resorts\n•Paul Stevens, Chief Operating Officer, Middle East, Africa, Turkey, Accor\n•Karin van den Berg, Senior Director of Operations Full-service Hotels UAE, Hilton\n•Sandeep Walia, Chief Operating Officer - Middle East, Marriott International\n",
        "private": false,
        "externalId": "sHoaWWUjAFnke",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Sustainable Hospitality Challenge",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 960,
        "endMinute": 1050,
        "descriptionHtml": "<p><span style=\"font-family: Arial, Helvetica, sans-serif;\">The Sustainable Hospitality Challenge is a Hotelschool The Hague initiative that aims to enhance the evolution of sustainable hospitality.</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\"><br></span></p><p><span style=\"font-family: Arial, Helvetica, sans-serif;\"><strong>Moderator</strong>: <strong>Paul Griep</strong>, Founder of Sustainable Hospitality Challenge, Director Industry Relations &amp; Alumni, Hotelschool The Hague&nbsp;</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\"><br></span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>SHC Judges:</strong></span></p><ul><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Colin Abercrombie</strong>, Strategy Director, NEOM Hotel Development</span><span style=\"font-family: Arial,Helvetica,sans-serif;\"><br></span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Bernadine Galliver</strong>, Vice President: Tourism Advisory, JLL’s Hotels &amp; Hospitality Group</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Guy Hutchinson</strong>, President &amp; CEO, Rotana<strong><br></strong></span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Glenn Mandziuk</strong>, Chief Executive Officer, Sustainable Hospitality Alliance&nbsp;</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Dimitris Manikis</strong>, President EMEA, Wyndham</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Haitham Mattar</strong>, Special Advisor, UNWTO , Managing Director MEA &amp; South West Asia, IHG Hotels &amp; Resorts</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Paul Stevens</strong>, Chief Operating Officer, Middle East, Africa, Turkey, Accor</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Karin van den Berg</strong>, Senior Director of Operations Full-service Hotels UAE, Hilton</span></span></li><li><span style=\"font-family: Arial, Helvetica, sans-serif;\"><strong>Sandeep Walia</strong>, Chief Operating Officer - Middle East, Marriott International</span></li></ul>",
        "id": 1168640
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "description": "The EAHM Leadership Series Workshop offers a unique opportunity for students to learn firsthand from industry leaders",
        "private": false,
        "speakers": [
            {
                "speakerId": 3134304,
                "role": "Moderator"
            },
            {
                "speakerId": 3134309,
                "role": "Moderator"
            },
            {
                "speakerId": 3079867
            },
            {
                "speakerId": 3074042
            },
            {
                "speakerId": 3126480
            },
            {
                "speakerId": 3089240
            }
        ],
        "externalId": "m6orwQWtmimcj",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 930,
        "descriptionHtml": "<p>The EAHM Leadership Series Workshop offers a unique opportunity for students to learn firsthand from industry leaders</p>",
        "id": 1224591
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Unveiling the Unique Value of Branded Residences in a Comparative Analysis of KSA and UAE.\n\n(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3084557
            }
        ],
        "externalId": "FXkAsqI3NiP2k",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Branded Residences: Value Addition to Hospitality Offerings",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 875,
        "endMinute": 890,
        "descriptionHtml": "<p>Unveiling the Unique Value of Branded Residences in a Comparative Analysis of KSA and UAE.<br><br>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1180737
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "Hosted by: James Hacon, \n\nMcCafferty's: \n\nOverview of Yas Bay’s Diverse Tenant Mix Curated by Miral Insight into how they have been chosen in order to work seamlessly together and create a dynamic and vibrant culinary ecosystem. \n\nPriya Chellani, Head of Asset Management, Miral \n\nMatthew Dadd, Acting General Manager , Yas Asset Management\n\n\n\n\nCentral:\n\n The Transformation of Eat-artainment Across Dining Spheres. What does it bring to a asset and how do you get it right?  \n\nDuncan Fraser-Smith, Author, Create to Plate\n\nIn conversation with \n\nSacha Daniel, Partner and Chief Operating Officer Solutions Group\n\n\n\n\nArt Market: \n\nCreating Community Hubs through Home Grown Concepts and Leveraging their Power in Business Operations \n\nMarc Williams, Owner, ART MARKET \n\nMatthew Dadd, Acting General Manager, Yas Asset Management\n\n\n\n\nCafe Del Mar:\n\nThe Evolution of Beach Clubs: A New Era for Hospitality Investments – Leveraging Brands to Create Real Estate and Bringing in Operators to Drive Revenue\n\nTurab Saleem, Partner - Head of Hospitality, Tourism & Leisure Advisory Services -MENA, Knight Frank \n\nIn conversation with \n\nMario Samaha, Executive Chairman & Founder , Capital Motion\n\nPriya Chellani, Head of Asset Management, Miral \n\nChristopher Hewett, SVP and Head of Hospitality, Al Hamra Real Estate",
        "private": false,
        "speakers": [
            {
                "speakerId": 3091935
            },
            {
                "speakerId": 3091980
            },
            {
                "speakerId": 3127594
            },
            {
                "speakerId": 3130903
            },
            {
                "speakerId": 3131462
            },
            {
                "speakerId": 3084557
            },
            {
                "speakerId": 3092756
            },
            {
                "speakerId": 3134268
            }
        ],
        "externalId": "exNAt1fSfRnet",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "F&B Concepts Tour (McCafferty's, Central, Art Market, Cafe del Mar)",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 1020,
        "descriptionHtml": "<p>Hosted by:<strong>&nbsp;James Hacon,&nbsp;</strong></p><p><strong>McCafferty's:&nbsp;</strong></p><p><strong>Overview of Yas Bay’s Diverse Tenant Mix Curated by Mir</strong><strong>al</strong> Insight into how they have been chosen in order to work seamlessly together and create a dynamic and vibrant culinary ecosystem.&nbsp;</p><p><strong>Priya Chellani,</strong> Head of Asset Management, Miral&nbsp;</p><p><strong>Matthew Dadd,</strong> Acting General Manager , Yas Asset Management</p><p><br></p><p><strong><u>Central:</u></strong></p><p><strong>&nbsp;The Transformation of Eat-artainment Across Dining Spheres.&nbsp;</strong>What does it bring to a asset and how do you get it right? &nbsp;</p><p><strong>Duncan Fraser-Smith,&nbsp;</strong>Author, Create to Plate</p><p>In conversation with&nbsp;</p><p><strong>Sacha Daniel,</strong> Partner and Chief Operating Officer Solutions Group</p><p><br></p><p><strong><u>Art Market:&nbsp;</u></strong></p><p><strong>Creating Community Hubs through Home Grown Concepts and Leveraging their Power in Business Operations&nbsp;</strong></p><p><strong>Marc Williams,&nbsp;</strong>Owner, ART MARKET&nbsp;</p><p><strong>Matthew Dadd,</strong> Acting General Manager, Yas Asset Management</p><p><br></p><p><strong><u>Cafe Del Mar:</u></strong></p><p><strong>The Evolution of Beach Clubs: A New Era for Hospitality Investments – Leveraging Brands to Create Real Estate and Bringing in Operators to Drive Revenue</strong></p><p><strong>Turab Saleem,&nbsp;</strong>Partner - Head of Hospitality, Tourism &amp; Leisure Advisory Services -MENA, Knight Frank<strong>&nbsp;</strong></p><p>In conversation with<strong>&nbsp;</strong></p><p><strong>Mario Samaha,</strong> Executive Chairman &amp; Founder , Capital Motion</p><p><strong>Priya Chellani,&nbsp;</strong>Head of Asset Management, Miral<strong>&nbsp;</strong></p><p><strong>Christopher Hewett,</strong> SVP and Head of Hospitality, Al Hamra Real Estate</p>",
        "id": 1198596
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Special Open Mic Sessions. This is a unique opportunity to address FHS delegates, and present innovations, strategic leadership or sustainable practices. Open to registered delegates only!\n\nModerators:\n\n•Fritz Dickamp, Managing Director, Studio 4  \n•David Keen, Founder & CEO, Quo \nFinalists:\n\n1.Alex Toledano, President, VISTO\n2.Judit Szollosi, Business Developer, Conceptional\n3.David Singleton, Portfolio Board Advisor, Transformational Growth Coach, Oraculi\n4.Fahad Mushayt, Chief Executive Officer, ASFAR\n5.Anouschka Menzies, Co Founder, Bacchus Agency\n6.Duncan Fraser-Smith, Managing Partner, Glee Hospitality Solutions\n7.Paul Boldly, Managing Partner, RLA Global\n8.Basma Aribi, FreshOnTable, Head of Marketing\n9.Radhika Arapally, Founder, Sustainability Kiosk\n10.Faisal Aktuwaim, Co-Founder & CEO, Oaktree Hospitality\n11.Ali Shahid, Marketing Director, the bench\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3089240,
                "role": "Moderator"
            },
            {
                "speakerId": 3127863,
                "role": "Moderator"
            },
            {
                "speakerId": 3127864,
                "role": "Moderator"
            },
            {
                "speakerId": 3138924
            },
            {
                "speakerId": 3138925
            },
            {
                "speakerId": 3138926
            },
            {
                "speakerId": 3138927
            },
            {
                "speakerId": 3127594
            },
            {
                "speakerId": 3138928
            },
            {
                "speakerId": 3138929
            },
            {
                "speakerId": 3138930
            },
            {
                "speakerId": 3138931
            },
            {
                "speakerId": 3126602
            }
        ],
        "externalId": "RVfx7gxVcRkog",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "How will you 'Lead The Change'?",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1020,
        "endMinute": 1080,
        "descriptionHtml": "<p><span style=\"font-family: Arial,Helvetica,sans-serif;\">Special Open Mic Sessions. This is a unique opportunity to address FHS delegates, and present innovations, strategic leadership or sustainable practices. Open to registered delegates only!</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">Moderators:</span></p><ul><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Fritz Dickamp</strong>, Managing Director, Studio 4 &nbsp;</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>David Keen</strong>, Founder &amp; CEO, Quo&nbsp;</span></li></ul><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">Finalists:</span></p><ol><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Alex Toled</strong><strong>ano</strong>, President, VISTO</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Judit Szollo</strong><strong>si</strong>, Business Developer, Conceptional</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>David Singleton</strong>, Portfolio Board Advisor, Transformational Growth Coach, Oraculi</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Fahad Mushayt</strong>, Chief Executive Officer, ASFAR</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Anouschka</strong></span> <span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Menzies</strong>, Co Founder, Bacchus Agency</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Duncan Fraser-Smith</strong>, Managing Partner, Glee Hospitality Solutions</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Paul Boldly</strong>, Managing Partner, RLA Global</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Basma Aribi</strong>, FreshOnTable, Head of Marketing</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Radhika Arapally</strong>, Founder, Sustainability Kiosk</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Faisal Aktuwaim</strong>, Co-Founder &amp; CEO, Oaktree Hospitality</span></li><li><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Ali Shahid</strong>, Marketing Director, the bench</span></li></ol>",
        "id": 1192738
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3126349,
                "role": "Moderator"
            },
            {
                "speakerId": 3124455
            },
            {
                "speakerId": 3099560
            },
            {
                "speakerId": 3087277
            },
            {
                "speakerId": 3079871
            }
        ],
        "externalId": "fXG8EqwlGA29V",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Shaping the Next Decade: The Evolution of Hotel Architecture in the Era of Technology, Sustainability, and Changing Traveler Preferences",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 620,
        "endMinute": 660,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1183050
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079903
            },
            {
                "speakerId": 3121102,
                "role": "Moderator"
            },
            {
                "speakerId": 3100239
            }
        ],
        "externalId": "dmyOAT5hjMiws",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Opportunity for Luxury Brand and Hotel Partnerships: Exploring Demand Trends and Collaboration Success Factors",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 780,
        "endMinute": 800,
        "id": 1168680
    },
    {
        "private": false,
        "externalId": "i3WdLC6mhcWwL",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Registration",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 510,
        "endMinute": 560,
        "id": 1180708
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079891,
                "role": "Moderator"
            },
            {
                "speakerId": 3079892
            },
            {
                "speakerId": 3121147
            },
            {
                "speakerId": 3081143
            },
            {
                "speakerId": 3099557
            }
        ],
        "externalId": "IEsvIgzp1w0wF",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 740,
        "endMinute": 780,
        "id": 1183059
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "description": "Delve into the future of Saudi tourism investments with this keynote, which outlines a vision of pioneering change, untapped potential, and successful growth strategies driving the industry's transformation.\n\n ",
        "private": false,
        "speakers": [
            {
                "speakerId": 3127118
            }
        ],
        "externalId": "gakdvEpgPvWP0",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Future of Saudi Tourism Investments",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 730,
        "endMinute": 740,
        "descriptionHtml": "<p>Delve into the future of Saudi tourism investments with this keynote, which outlines a vision of pioneering change, untapped potential, and successful growth strategies driving the industry's&nbsp;transformation.</p><p aria-hidden=\"true\">&nbsp;</p>",
        "id": 1207174
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3131684,
                "role": "Moderator"
            },
            {
                "speakerId": 3132778
            },
            {
                "speakerId": 3132590
            },
            {
                "speakerId": 3138896
            }
        ],
        "externalId": "WdipEfJiGElqi",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "CLOSED DOOR SESSION: Powering Sustainable Growth: Abu Dhabi's Green Project",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 540,
        "endMinute": 570,
        "id": 1180695
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3101353
            }
        ],
        "externalId": "tDVAz0puw7FSM",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Setting the Scene for GRIF – A Focus on Hotel F&B  ",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 560,
        "endMinute": 570,
        "id": 1227724
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072437,
                "role": "Moderator"
            },
            {
                "speakerId": 3072777
            }
        ],
        "externalId": "Kffc66jj2EDH0",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Evolutionary Journey of Established Hotel Chains in the Face of Change",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 620,
        "endMinute": 635,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1185961
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3123688
            }
        ],
        "externalId": "ERhPKpTVTGW1g",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Power of AI: How Artificial Intelligence is Transforming Business Decision Making",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 890,
        "endMinute": 915,
        "descriptionHtml": "<p>(Streaming live on<a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">&nbsp;LinkedIn</a>)</p>",
        "id": 1168639
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3114265
            }
        ],
        "externalId": "EgldFM5tnefQh",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Opening Remarks: A Warm Welcome from Abu Dhabi!",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 640,
        "endMinute": 660,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1188906
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3084484,
                "role": "Moderator"
            },
            {
                "speakerId": 3125996
            },
            {
                "speakerId": 3125995
            }
        ],
        "externalId": "UZBl5F5Iz4wwc",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Hospitality Talent Pipeline: From Job to Career - A Think Tank for Developing and Attracting the Best Industry Professionals",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 0,
        "endMinute": 810,
        "id": 1180705
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "externalId": "6uocDyfvaS7B4",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Ongoing Networking Coffee Break",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 930,
        "endMinute": 990,
        "id": 1168666
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    432689
                ]
            }
        ],
        "description": "You are invited to the FHS After Party, at Lock, Stock & Barrel Yas Bay, Abu Dhabi, hosted by Solutions Group. Following the FHS reception, join us in continuing the connections and kick back at the region’s most awarded party bar. With live music, mouthwatering bites and all the best in entertainment, as an FHS attendee, we’ll be kicking on with a private area and bar and the best stage views for all the action!  ",
        "private": false,
        "externalId": "pF1qsRm6THsbG",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "FHS After Party - Lock, Stock & Barrel Yas Bay, Abu Dhabi ",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1260,
        "endMinute": 1380,
        "descriptionHtml": "<p>You are invited to the FHS After Party, at Lock, Stock &amp; Barrel Yas Bay, Abu Dhabi, hosted by Solutions Group. Following the FHS reception, join us in continuing the connections and kick back at the region’s most awarded party bar. With live music, mouthwatering bites and all the best in entertainment, as an FHS attendee, we’ll be kicking on with a private area and bar and the best stage views for all the action! &nbsp;</p>",
        "id": 1220786
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    414723
                ]
            }
        ],
        "description": "Lace-up your running shoes and immerse yourself in the invigorating coastal breeze as we embark on a 5 km journey along the waterfront just outside the hotel that combines physical fitness with mental rejuvenation.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3126602
            }
        ],
        "externalId": "M9zmRvGgk0qUo",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Morning Run",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 420,
        "endMinute": 480,
        "descriptionHtml": "<p>Lace-up your running shoes and immerse yourself in the invigorating coastal breeze as we embark on a 5 km journey along the waterfront just outside the hotel that combines physical fitness with mental rejuvenation.</p>",
        "id": 1170834
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    414723
                ]
            }
        ],
        "description": "The conference may have ended but you can continue networking by choosing from a selection of tours and activities:\n\n•Louvre Abu Dhabi\n•Kayaking & Mangrove Tree Planting\n•Golf Tournament\nPlaces on these tours are limited and available on a first-come, first-served basis.\n\nAlternatively, if you are staying at Hilton Abu Dhabi Yas Island or The WB Abu Dhabi, Curio Collection by Hilton, every night stay at the property has an included access to theme parks and a waterpark, choice of 1 park per day (Ferrari World Abu Dhabi, Warner Bros World Abu Dhabi, Yas Waterworld Abu Dhabi).",
        "private": false,
        "externalId": "kLNU2AURC937D",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Tours & Activities",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 1020,
        "descriptionHtml": "<p>The conference may have ended but you can continue networking by choosing from a selection of tours and activities:</p><ul><li>Louvre Abu Dhabi</li><li>Kayaking &amp; Mangrove Tree Planting</li><li>Golf Tournament</li></ul><p>Places on these tours are limited and available on a first-come, first-served basis.<br><br><strong>Alternatively, if you are staying at Hilton Abu Dhabi Yas Island or The WB Abu Dhabi, Curio Collection by Hilton, every night stay at the property has an included access to theme parks and a waterpark, choice of 1 park per day (Ferrari World Abu Dhabi, Warner Bros World Abu Dhabi, Yas Waterworld Abu Dhabi).</strong></p>",
        "id": 1170839
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3101358
            }
        ],
        "externalId": "iyJE12s28csEV",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Tapping into New F&B Data for Hotels and How it Can Drive Strategy for Decision Making",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 650,
        "endMinute": 660,
        "id": 1198580
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    432689
                ]
            }
        ],
        "description": "Join us at the opening reception of FHS at ‘Stage 16’, located at the World’s First Warner Bros. themed hotel, The WB™ Abu Dhabi, Curio Collection by Hilton™.\n\n\n\n\nThis will be the perfect opportunity to connect with like-minded attendees and expand your professional network, step into a world of colour and creativity.",
        "private": false,
        "externalId": "AVMIkS5ytjQSc",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Welcome Reception at ‘Stage 16’ at The WB™ Abu Dhabi, Curio Collection by Hilton™",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 1110,
        "endMinute": 1260,
        "descriptionHtml": "<p>Join us at the opening reception of FHS at ‘Stage 16’, located at the World’s First Warner Bros. themed hotel, The WB™ Abu Dhabi, Curio Collection by Hilton™.</p><p><br></p><p>This will be the perfect opportunity to connect with like-minded attendees and expand your professional network, step into a world of colour and creativity.</p>",
        "id": 1168647
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3121102
            }
        ],
        "externalId": "Tlkx2nRq2TDOK",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Closing Remarks",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1075,
        "endMinute": 1080,
        "id": 1226068
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3132922,
                "role": "Moderator"
            },
            {
                "speakerId": 3091265
            },
            {
                "speakerId": 3125252
            }
        ],
        "externalId": "FKcS0jJH6ZxH8",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Business Case for ESG Integration: Exploring the Commercial Benefits and Opportunities for Real Estate Investors and Developers",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1000,
        "endMinute": 1020,
        "id": 1168667
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3101500,
                "role": "Moderator"
            },
            {
                "speakerId": 3132667
            },
            {
                "speakerId": 3127285
            },
            {
                "speakerId": 3093396
            },
            {
                "speakerId": 3085238
            }
        ],
        "externalId": "db4QRW9YGmxat",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Hotel Transactions: Insights for 2023",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 935,
        "endMinute": 970,
        "id": 1176636
    },
    {
        "private": false,
        "speakers": [
            {
                "speakerId": 3080558
            }
        ],
        "externalId": "I6qDNY7HE00nz",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Closing Remarks",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 800,
        "endMinute": 810,
        "id": 1230424
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3100883,
                "role": "Moderator"
            },
            {
                "speakerId": 3096121,
                "role": ""
            },
            {
                "speakerId": 3094074,
                "role": ""
            },
            {
                "speakerId": 3119031
            },
            {
                "speakerId": 3091361
            }
        ],
        "externalId": "7cOECNhZR0WRr",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Strategic Financing of Hospitality Assets: Navigating Uncertainty and Rising Interest Rates for Optimal Funding Solutions",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 725,
        "endMinute": 760,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168663
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072437,
                "role": "Moderator"
            },
            {
                "speakerId": 3086004
            }
        ],
        "externalId": "zmUgIILR5BrWz",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Key Emerging Global Trends Shaping Tourism Development Strategies\t",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 760,
        "endMinute": 780,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168661
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3121102,
                "role": ""
            }
        ],
        "externalId": "2eMgKMUUzKq9q",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Welcome to FHS Intelligence Talks",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 825,
        "endMinute": 830,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1177361
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3099582
            },
            {
                "speakerId": 3093394
            },
            {
                "speakerId": 3125254
            },
            {
                "speakerId": 3085096
            },
            {
                "speakerId": 3130742,
                "role": "Moderator"
            }
        ],
        "externalId": "o0RtBef8eFb2C",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Preserving Legacy: Embracing Heritage in Hospitality Design",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 570,
        "endMinute": 605,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1180738
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    414723
                ]
            }
        ],
        "description": "A 60 min low impact full body strength class using body weight and band resistance to maximize the workout. Be ready to feel the burn and get those muscles working. Suitable for all levels.",
        "private": false,
        "externalId": "quR3xb3kr0Zw6",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Mini-band Strength",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 420,
        "endMinute": 480,
        "descriptionHtml": "<p>A 60 min low impact full body strength class using body weight and band resistance to maximize the workout. Be ready to feel the burn and get those muscles working. Suitable for all levels.</p>",
        "id": 1170837
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    432689
                ]
            }
        ],
        "description": "The luxurious 5-star Saadiyat Rotana Resort & Villas is situated on a spectacular 9 km stretch of pristine white beach on the breathtaking Saadiyat Island, which is also home to indigenous Hawksbill turtles. The resort, which embodies the island, combines cultural, entertainment and natural elements of the Abu Dhabi emirate.\n\nAmongst many facilities and Food & Beverage venues, Saadiyat Rotana Resort & Villas offers a stunning beachfront bar called “Nasma” offering superb sea views along with the most relaxed vibes on Saadiyat Island. Join us and experience the ultimate vibes with an exciting menu on offer! Escape to paradise and indulge in a tropical oasis at Nasma beachfront bar.",
        "private": false,
        "externalId": "QwcwfrSoGYRsH",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Evening Reception Hosted by Rotana at Saadiyat Rotana Resort & Villas (Nasma Beachfront Bar)",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1110,
        "endMinute": 1260,
        "descriptionHtml": "<p>The luxurious 5-star Saadiyat Rotana Resort &amp; Villas is situated on a spectacular 9 km stretch of pristine white beach on the breathtaking Saadiyat Island, which is also home to indigenous Hawksbill turtles. The resort, which embodies the island, combines cultural, entertainment and natural elements of the Abu Dhabi emirate.</p><p>Amongst many facilities and Food &amp; Beverage venues, Saadiyat Rotana Resort &amp; Villas offers a stunning beachfront bar called “Nasma” offering superb sea views along with the most relaxed vibes on Saadiyat Island. Join us and experience the ultimate vibes with an exciting menu on offer! Escape to paradise and indulge in a tropical oasis at Nasma beachfront bar.</p>",
        "id": 1168672
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3092776,
                "role": "Moderator"
            },
            {
                "speakerId": 3133679
            },
            {
                "speakerId": 3126298
            },
            {
                "speakerId": 3113722
            }
        ],
        "externalId": "MBWHkTQfSCgoG",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Evolution of Hotel Investment in Africa",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 730,
        "endMinute": 760,
        "id": 1168689
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3081159,
                "role": "Moderator"
            },
            {
                "speakerId": 3135171
            },
            {
                "speakerId": 3093402
            },
            {
                "speakerId": 3128676
            },
            {
                "speakerId": 3130300
            }
        ],
        "externalId": "faS0rJGDzlHKY",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Hospitality Development in Saudi Arabia: Transforming our World - Vision 2030",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 865,
        "endMinute": 900,
        "id": 1177354
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3134272
            },
            {
                "speakerId": 3134271
            },
            {
                "speakerId": 3135521
            },
            {
                "speakerId": 3134275
            }
        ],
        "externalId": "BY1MTLzzHAyYg",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Experiential Lodging: How Ecolodges and Modular Construction are Merging to Become the Biggest Trend in Hospitality Development",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 975,
        "endMinute": 1020,
        "id": 1226052
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Judges:\n\n•    Jordan Bray, Vice President UAE Director, Plug and Play\n\n•    Hasan Haider, Founder, and Managing Partner, Plus Venture Capital +VC\n\n•    Jonathan Worsley, Chairman & CEO, The Bench\n\n•    Mark Zawacki, Managing Director, Techne Infiniti Ventures\n\n\n\n\nFinalists:\n\n•    Karim Abboud, Director EMEA, Klimato\n\n•    Saujanya Acharya, CEO & Co-Founder, Neumo\n\n•    Marco Corallo, COO & Co-Founder, Xenios Academy\n\n•    Erika Doyle, Founder & Owner, Drink Dry\n\n•    Mona Faraj, Co-Founder & CEO, ExploreTECH\n\n•    Joseph Jacob, Co-Founder & CEO, Burnt\n\n•    Puneet Mahindroo, Co-Founder, PerfectCheck\n\n•    Khalid Maliki, Co-founder & COO, Gimly\n\n•    Arul Prakash, Co-Founder & CEO, Buk Technology\n\n•    Osama Shawky, CEO / Co-Founder, Thirty Sleeps\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3087503
            },
            {
                "speakerId": 3130666
            },
            {
                "speakerId": 3080558
            },
            {
                "speakerId": 3128865
            },
            {
                "speakerId": 3126079
            },
            {
                "speakerId": 3129373
            },
            {
                "speakerId": 3129376
            },
            {
                "speakerId": 3129714
            },
            {
                "speakerId": 3128993
            },
            {
                "speakerId": 3129372
            },
            {
                "speakerId": 3129375
            },
            {
                "speakerId": 3129724
            },
            {
                "speakerId": 3126072
            },
            {
                "speakerId": 3126316
            }
        ],
        "externalId": "dya7AHlMPJa0t",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Startup Den",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 870,
        "endMinute": 990,
        "descriptionHtml": "<p><strong><span style=\"font-family: Arial,Helvetica,sans-serif;\">Judges:</span></strong></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Jordan Bray</strong>, Vice President UAE Director, Plug and Play</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Hasan Haide</strong>r, Founder, and Managing Partner, Plus Venture Capital +VC</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; <strong>&nbsp;Jonathan Worsley</strong>, Chairman &amp; CEO, The Bench</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Mark Zawac</strong><strong>ki,</strong> Managing Director, Techne Infiniti Ventures</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\"><br></span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\"><strong>Finalists:</strong></span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Karim Abboud</strong>, Director EMEA, Klimato</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Saujanya Acharya</strong>, CEO &amp; Co-Founder, Neumo</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Marco Corall</strong><strong>o</strong>, COO &amp; Co-Founder, Xenios Academy</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Erika Doyle</strong>, Founder &amp; Owner, Drink Dry</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; <strong>&nbsp;Mona Faraj</strong>, Co-Founder &amp; CEO, ExploreTECH</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; <strong>&nbsp;Joseph Jacob</strong>, Co-Founder &amp; CEO, Burnt</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp;<strong>&nbsp; Puneet Mahindroo</strong>, Co-Founder, PerfectCheck</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp;<strong>&nbsp; Khalid Maliki</strong>, Co-founder &amp; COO, Gimly</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Arul Prakash</strong>, Co-Founder &amp; CEO, Buk Technology</span></p><p><span style=\"font-family: Arial,Helvetica,sans-serif;\">• &nbsp; &nbsp;<strong>Osama Shawky</strong>, CEO / Co-Founder, Thirty Sleeps</span></p><p><br></p>",
        "id": 1168641
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3100883,
                "role": "Moderator"
            },
            {
                "speakerId": 3119641
            }
        ],
        "externalId": "MKbEF4PbvrjGi",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Fireside Chat on Immersive and Decentralized Media Experiences with Web3, Blockchain, AI, and NFTs",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 970,
        "endMinute": 985,
        "id": 1205431
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3090566,
                "role": "Moderator"
            },
            {
                "speakerId": 3088005
            }
        ],
        "externalId": "3bixe1fprkcjN",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Embracing Sustainability: Paving the Pathway to Net Positive Hospitality",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 985,
        "endMinute": 1000,
        "id": 1168665
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072434,
                "role": "Moderator"
            },
            {
                "speakerId": 3095299
            }
        ],
        "externalId": "tGYo7tTvH6oxj",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "\"A Global Entrepreneur’s Vision\" - Stephen Sackur, Presenter of HARDtalk in an Exclusive Fireside Chat with H.E. Mohamed Ali Rashed Alabbar",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 660,
        "endMinute": 680,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1192719
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3099535
            }
        ],
        "externalId": "IcVISqE1e9XbV",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Economic Analysis: Assessing the Impact of Global Conflicts, Interest Rates, and Supply Challenges on Hospitality Industry in the Middle East",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 535,
        "endMinute": 565,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168649
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Winner Presentation & Award Giving\n\n(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3084471
            },
            {
                "speakerId": 3138944
            },
            {
                "speakerId": 3130832
            },
            {
                "speakerId": 3087271
            },
            {
                "speakerId": 3088005
            }
        ],
        "externalId": "wDLs5r8McjEyt",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 710,
        "endMinute": 725,
        "descriptionHtml": "<p>Winner Presentation &amp; Award Giving<br><br>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168657
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "Leadership Award - Winner Presentation & Award Giving - Amine E. Moukarzel Ph.D, President, Golden Tulip - MENA Region\n\nLeadership Award - Winner Presentation & Award Giving - Guido E. De Wilde, Hospitality Advisor, Wasl Hospitality\n\n(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3139038
            },
            {
                "speakerId": 3080558,
                "role": "Moderator"
            },
            {
                "speakerId": 3132767
            },
            {
                "speakerId": 3133623
            }
        ],
        "externalId": "AWBLDGMkPxUK0",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "FHS Awards",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 660,
        "endMinute": 690,
        "descriptionHtml": "<p><strong>Leadership Award - Winner Presentation &amp; Award Giving -</strong> Amine E. Moukarzel Ph.D, President, Golden Tulip - MENA Region</p><p><strong>Leadership Award - Winner Presentation &amp; Award Giving -&nbsp;</strong>Guido E. De Wilde, Hospitality Advisor, Wasl Hospitality</p><p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168677
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3100892,
                "role": "Moderator"
            },
            {
                "speakerId": 3130743
            },
            {
                "speakerId": 3125962
            },
            {
                "speakerId": 3125967
            }
        ],
        "externalId": "2SOi9rL5rsk3z",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Converging Digital Transformation in Hospitality: Cross-Industry Best Practices and Implementation Strategies",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 570,
        "endMinute": 600,
        "id": 1192730
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3096162,
                "role": "Moderator"
            },
            {
                "speakerId": 3121260
            },
            {
                "speakerId": 3125979
            },
            {
                "speakerId": 3126278
            },
            {
                "speakerId": 3134276
            }
        ],
        "externalId": "fyEc8TSeUV59B",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Creating Thriving Mixed-Use Developments: The Synergy of Culture, Entertainment and Hospitality",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 620,
        "endMinute": 660,
        "id": 1192733
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3081167
            },
            {
                "speakerId": 3098957
            },
            {
                "speakerId": 3092064
            },
            {
                "speakerId": 3115234
            },
            {
                "speakerId": 3120164,
                "role": "Moderator"
            }
        ],
        "externalId": "nanGKBH316stk",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Rise of Third-Party Operators in Hotel Management: What are the Advantages over Traditional Models and How to Find the Right Solution for Investors",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 900,
        "endMinute": 940,
        "id": 1183137
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3089650,
                "role": "Moderator"
            },
            {
                "speakerId": 3114775
            },
            {
                "speakerId": 3084477
            },
            {
                "speakerId": 3116570
            },
            {
                "speakerId": 3124418
            }
        ],
        "externalId": "DwuPwTAuMuRkO",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Building Hotels in a Challenging Environment: Navigating Rising Construction Costs, Funding Delays, and Higher Interest Rates for Hotel Development Projects",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 690,
        "endMinute": 730,
        "id": 1168674
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3092819
            }
        ],
        "externalId": "Efnl21poQPrM5",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Unveiling One of 'The Largest Hospitality Projects In The World'",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 900,
        "endMinute": 915,
        "id": 1188907
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3138913,
                "role": "Moderator"
            },
            {
                "speakerId": 3079940
            },
            {
                "speakerId": 3128636
            }
        ],
        "externalId": "C0tVTlymZDrpX",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "The Dynamic Landscape of Asset Management in the Region",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 1000,
        "endMinute": 1020,
        "id": 1185963
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3100884
            }
        ],
        "externalId": "jdUymLbVLHAB6",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "What are the Numbers Telling Us? A Look at Hotel Performance Across the Middle East",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 830,
        "endMinute": 845,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1198127
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079891,
                "role": "Moderator"
            },
            {
                "speakerId": 3072434
            }
        ],
        "externalId": "JReRCvLyH3Kny",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Turning the Tables: Hard Talk of Stephen Sackur on his view of Global Journalism in a Changing World",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 850,
        "id": 1198128
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3089240,
                "role": "Moderator"
            },
            {
                "speakerId": 3130744
            },
            {
                "speakerId": 3119039
            }
        ],
        "externalId": "8XEGSWW7EKAoz",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Embracing the Era of the Digital Traveler: Transforming Hotel Operations for the Future",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 600,
        "endMinute": 620,
        "id": 1185964
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    437516
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3113529
            }
        ],
        "externalId": "5MOcqtyZXrmFN",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Workshop: Operating Cost in Relation to Energy-efficient Equipment",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 570,
        "endMinute": 615,
        "id": 1200814
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "Explore groundbreaking concepts that will redefine the future of F&B and hospitality industry",
        "private": false,
        "speakers": [
            {
                "speakerId": 3135112
            }
        ],
        "externalId": "ajPGmYaHl1y1j",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Anticipating the Future Normal",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 570,
        "endMinute": 590,
        "descriptionHtml": "<p>Explore groundbreaking concepts that will redefine the future of F&amp;B and hospitality industry</p>",
        "id": 1226773
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3079941,
                "role": "Moderator"
            },
            {
                "speakerId": 3136036
            },
            {
                "speakerId": 3094985
            },
            {
                "speakerId": 3094984
            }
        ],
        "externalId": "jnbfGAv2gORJd",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Tapping into the $4.7 Trillion Wellness Industry",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 700,
        "endMinute": 730,
        "id": 1183145
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3126602
            }
        ],
        "externalId": "l9lDbUlHbjd6j",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Announcements & Signing Ceremonies",
        "startDate": "2023-09-27T00:00:00.000+0000",
        "endDate": "2023-09-27T23:59:59.000+0000",
        "startMinute": 630,
        "endMinute": 690,
        "id": 1204426
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414718
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "private": false,
        "speakers": [
            {
                "speakerId": 3120166
            },
            {
                "speakerId": 3088608
            },
            {
                "speakerId": 3088610
            },
            {
                "speakerId": 3125247
            },
            {
                "speakerId": 3117175,
                "role": "Moderator"
            }
        ],
        "externalId": "qSsFtCUd5WC27",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Building Sustainable Hospitality: Setting the Scene for Hotel Development in the Middle East",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 840,
        "endMinute": 880,
        "id": 1184431
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "Russian, Ukrainian, Kazakhi, Uzbeki travellers and new residents. \n\nIrina Orlandini, Founder and CEO, SPAECIAL visionary producers and Like4Like Hospitality Strategies\n\n\n\n\nChinese tourists and the increasing influx of Chinese business and MICE travellers to the region.\n\nPeggy Li, Managing Partner at SPS: Affinity\n\n\n",
        "private": false,
        "speakers": [
            {
                "speakerId": 3091295
            },
            {
                "speakerId": 3101361
            }
        ],
        "externalId": "TWKIIbmbAhkPc",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Catering to New Crucial Demographics: How Can a Hotel F&B Offering Get Them Excited and Become a Marketing Anchor for This New Audience?",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 725,
        "endMinute": 750,
        "descriptionHtml": "<p><strong>Russian, Ukrainian, Kazakhi, Uzbeki travellers and new residents. </strong></p><p><strong>Irina Orlandini</strong>, Founder and CEO, SPAECIAL visionary producers and Like4Like Hospitality Strategies</p><p><br></p><p><strong>Chinese tourists and the increasing influx of Chinese business and MICE travellers to the region.</strong></p><p><strong>Peggy Li</strong>, Managing Partner at SPS: Affinity</p><p><br></p>",
        "id": 1198584
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414721,
                    414723
                ]
            }
        ],
        "description": "Start your day with this 60 min yoga flow designed for all levels.  Shake off sleepy vibes, wake up your muscles, and bring movement to your body. In this class you’ll open your hips, legs, back, and shoulders and at the end you’ll feel physically and mentally refreshed ready to enjoy the day ahead.\n\n\n",
        "private": false,
        "externalId": "5VrlB9QVgbaeL",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Energising Yoga Flow",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 420,
        "endMinute": 480,
        "descriptionHtml": "<p>Start your day with this 60 min yoga flow designed for all levels. &nbsp;Shake off sleepy vibes, wake up your muscles, and bring movement to your body. In this class you’ll open your hips, legs, back, and shoulders and at the end you’ll feel physically and mentally refreshed ready to enjoy the day ahead.</p><p><br></p>",
        "id": 1170833
    },
    {
        "filters": [
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "private": false,
        "externalId": "43oA3OjXIalAO",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Return Back to Hilton",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 1020,
        "endMinute": 1050,
        "id": 1226801
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414720
                ]
            }
        ],
        "description": "Understanding not only the environmental but economic benefits.",
        "private": false,
        "speakers": [
            {
                "speakerId": 3097950,
                "role": "Moderator"
            },
            {
                "speakerId": 3119455
            },
            {
                "speakerId": 3091296
            }
        ],
        "externalId": "0LfDgZPFNgniN",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "No Time to Waste: Driving Social Impact and Operational Efficiency in the Food Value Chain",
        "startDate": "2023-09-25T00:00:00.000+0000",
        "endDate": "2023-09-25T23:59:59.000+0000",
        "startMinute": 750,
        "endMinute": 790,
        "descriptionHtml": "<p>Understanding not only the environmental but economic benefits.</p>",
        "id": 1198585
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3080558,
                "role": "Moderator"
            },
            {
                "speakerId": 3087153
            },
            {
                "speakerId": 3133563
            }
        ],
        "externalId": "Kl3rOaK2nEBU4",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Expanding Horizons for Hospitality: Leveraging the Surge in Investment Demand",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 600,
        "endMinute": 620,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168659
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072434,
                "role": "Moderator"
            },
            {
                "speakerId": 3130832
            }
        ],
        "externalId": "DnsCJUZbzewZd",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Redefining the Future: A New Generation of Leadership in Hospitality",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 695,
        "endMinute": 710,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1224565
    },
    {
        "filters": [
            {
                "id": 68770,
                "tags": [
                    414717
                ]
            },
            {
                "id": 68771,
                "tags": [
                    414721
                ]
            }
        ],
        "description": "(Streaming live on LinkedIn)",
        "private": false,
        "speakers": [
            {
                "speakerId": 3072434,
                "role": "Moderator"
            },
            {
                "speakerId": 3087271
            }
        ],
        "externalId": "W6wTL9AVUvn4I",
        "registrationFull": false,
        "hidden": false,
        "sessionCardSize": "large",
        "allowRating": false,
        "associatedContacts": {},
        "registration": false,
        "registrationVisibility": false,
        "registrationCapacityEnable": false,
        "enableVirtualSession": false,
        "title": "Navigators of Change: Insights of a CEO’s Journey",
        "startDate": "2023-09-26T00:00:00.000+0000",
        "endDate": "2023-09-26T23:59:59.000+0000",
        "startMinute": 680,
        "endMinute": 695,
        "descriptionHtml": "<p>(Streaming live on <a href=\"https://www.linkedin.com/showcase/future-hospitality-summit/\" rel=\"noopener noreferrer\" target=\"_blank\">LinkedIn</a>)</p>",
        "id": 1168653
    }
]